import { inject, Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable, shareReplay } from 'rxjs'
import { environment } from '../../../../environments/environment'

export interface AgencySelectItem {
  id: number
  ref: string | null
  name: string
  postalCode: string | null
  locality: string | null
  idAbm: number | null
  idNrj: number | null
}

@Injectable({ providedIn: 'root' })
export class AgenciesService {
  private http = inject(HttpClient)
  private planifyApiUrl = environment.planifyApiUrl

  /**
   * Cache par source ERP : le référentiel agences bouge rarement, inutile de
   * recharger 1000+ lignes à chaque ouverture du dialog (shareReplay conserve
   * la dernière réponse pour toute la durée de la session).
   */
  private cache = new Map<string, Observable<AgencySelectItem[]>>()

  /**
   * Agences pour un select, filtrables par source ERP : seules les agences
   * existant dans l'ERP cible sont proposées (requis pour la création EROS).
   */
  getForSelect(erpSource?: 'abm' | 'nrj') {
    const cacheKey = erpSource ?? 'all'

    let cached = this.cache.get(cacheKey)
    if (!cached) {
      let params = new HttpParams()
      if (erpSource) {
        params = params.set('erpSource', erpSource)
      }
      cached = this.http
        .get<AgencySelectItem[]>(`${this.planifyApiUrl}/agencies/select`, {
          params,
        })
        .pipe(shareReplay({ bufferSize: 1, refCount: false }))
      this.cache.set(cacheKey, cached)
    }

    return cached
  }
}
